import { render, staticRenderFns } from "./learning-strands-rating.vue?vue&type=template&id=298a0be2&scoped=true"
import script from "./learning-strands-rating.vue?vue&type=script&lang=js"
export * from "./learning-strands-rating.vue?vue&type=script&lang=js"
import style0 from "./learning-strands-rating.vue?vue&type=style&index=0&id=298a0be2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298a0be2",
  null
  
)

export default component.exports